import React from 'react'
import { compose } from 'recompose'
import { connect, FieldArray } from 'formik'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import Row from '@src/components/AdvertisingCampaign/Form/Row'
import InputGroup from '@src/components/AdvertisingCampaign/Form/InputGroup'
import InputTooltip from '@src/components/AdvertisingCampaign/Form/InputTooltip'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { ACTION_MAX_LENGTH, ADVANTAGES_MAX_LENGTH } from '@src/constants/AdvertisingBriefs'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface HOCProps {
  formik: Formik
}

const StepThree: React.FC<HOCProps> = props => {
  const {
    formik: { values, errors, touched }
  } = props

  return (
    <Step title="Brief.search.step.three.title">
      <Row>
        <GroupHead
          title="Brief.search.step.three.head.title"
          subTitle="Brief.search.step.three.head.subTitle"
        />
        <InputGroup>
          <FieldArray
            name={FIELD_NAMES.ADVANTAGES}
            render={() => (
              <React.Fragment>
                {values.advantages.map((advantage, index) => (
                  <InputTooltip
                    key={index}
                    name={`advantages[${index}][text]`}
                    value={values[FIELD_NAMES.ADVANTAGES][index]['text']}
                    inputMaxLength={ADVANTAGES_MAX_LENGTH}
                    isValid={
                      !(
                        errors.advantages &&
                        errors.advantages[index] &&
                        errors.advantages[index]!['text']
                      ) ||
                      !(
                        touched.advantages &&
                        touched.advantages[index] &&
                        touched.advantages[index]!['text']
                      )
                    }
                  />
                ))}
              </React.Fragment>
            )}
          />
        </InputGroup>
      </Row>
      <Row>
        <GroupHead
          title="Brief.search.action.head.title"
          subTitle="Brief.search.action.head.subTitle"
          notRequired={true}
        />
        <InputTooltip
          inputMaxLength={ACTION_MAX_LENGTH}
          name={FIELD_NAMES.PROMO_ACTION}
          value={values[FIELD_NAMES.PROMO_ACTION]}
          isValid={!errors[FIELD_NAMES.PROMO_ACTION] || !touched[FIELD_NAMES.PROMO_ACTION]}
        />
      </Row>
    </Step>
  )
}

export default compose(connect)(StepThree)
